import { render, staticRenderFns } from "./deliveryFeeCreation.vue?vue&type=template&id=29eaacf0&scoped=true&"
import script from "./deliveryFeeCreation.vue?vue&type=script&lang=js&"
export * from "./deliveryFeeCreation.vue?vue&type=script&lang=js&"
import style0 from "./deliveryFeeCreation.vue?vue&type=style&index=0&id=29eaacf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eaacf0",
  null
  
)

export default component.exports